export default __webpack_public_path__ + "static/media/19_mobile.35556be0.jpg";